// Regex to match max water depth layer: :depth-max-preview or :depth-max-dtri
// Applied to the 'code' of a layer of a scenario
export const MAX_WATER_DEPTH_LAYER_REGEX = /:depth-max-(preview|dtri)$/;

// Backend uses "features" as the layer id for all vector layers
export const VECTOR_LAYER_ID = "features";
